import PropTypes from 'prop-types';
import React, { Component } from 'react';
import _ from 'lodash';
import { reduxForm } from 'redux-form';
import Textarea from 'react-textarea-autosize';
import classNames from 'classnames';
import mapProps from 'recompose/mapProps';
import { CameraIcon } from '../../components/icons';
import CommentFormImage from '../../components/comment-form-image';
import withTranslate from '../../hoc/with-translate';
import withFontClassName from '../../hoc/with-font-class-name';
import getImageUrl from '../../services/get-image-url';
import isDataUrl from '../../services/is-data-url';
import convertSimpleCommentToContentState from '../../services/convert-simple-comment-to-content-state';
import styles from './comment-bar.scss';

export class CommentBar extends Component {
  componentWillReceiveProps = ({ fields: { content } }) => {
    if (this.contentInput && content.active && document.activeElement !== this.contentInput) {
      this.contentInput.focus();
    }
  };

  handleContentChange = event => {
    this.props.onChange();
    this.props.fields.content.onChange(event);
  };

  handleFileChange = event => this.props.onImageChange(event.target.files[0]);

  renderImage() {
    const { fields: { image: { value } }, onImageDelete: handleImageDelete } = this.props;

    if (!value) {
      return null;
    }

    let src = value;
    const isLoading = isDataUrl(src);

    if (!isLoading) {
      src = getImageUrl(value);
    }

    return <CommentFormImage src={src} isLoading={isLoading} onDelete={handleImageDelete}/>;
  }

  renderUploadButton() {
    const { fields: { image } } = this.props;

    if (image.value) {
      return null;
    }

    return (
      <div className={classNames(styles.uploadButton, 'comment-form__camera-icon')}>
        <CameraIcon className="forum-icon-fill"/>
        <input className={styles.fileInput} type="file" onChange={this.handleFileChange} accept="image/*"/>
      </div>
    );
  }

  setContentInput = ref => (this.contentInput = ref);

  render = () => {
    const { fields: { content, image }, submitting, invalid, handleSubmit, t, contentFontClassName } = this.props;
    const isButtonVisible = content.active || content.value.length || image.value;
    const buttonClassName = classNames(styles.saveButton, 'button-secondary-text-color', 'comment-bar__send-button', {
      [styles.hidden]: !isButtonVisible,
    });

    return (
      <div className={contentFontClassName}>
        <div className={classNames(styles.container, 'forum-text-color', 'comment-bar')}>
          <div className={styles.content}>
            <Textarea
              ref={this.setContentInput}
              value={content.value}
              className={classNames(styles.textArea, 'comment-bar__content')}
              placeholder={t('text-editor.comment-placeholder')}
              onChange={this.handleContentChange}
            />
            {this.renderImage()}
          </div>
          <div className={styles.buttonContainer}>
            {this.renderUploadButton()}
            <button className={buttonClassName} disabled={submitting || invalid} onClick={handleSubmit}>
              {t('comment-bar.send')}
            </button>
          </div>
        </div>
      </div>
    );
  };
}

CommentBar.propTypes = {
  onChange: PropTypes.func,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onImageChange: PropTypes.func.isRequired,
  onImageDelete: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  submitting: PropTypes.bool,
  t: PropTypes.func,
  invalid: PropTypes.bool,
  contentFontClassName: PropTypes.string.isRequired,
};

const formConfig = {
  form: 'comment',
  fields: ['content', 'ownerId', 'image'],
  validate: ({ image, content }) => {
    if (!image && !content) {
      return { content: 'empty' };
    }

    if (isDataUrl(image)) {
      return { image: 'loading' };
    }
  },
};

const mapper = props => ({
  ...props,
  onSubmit: comment => props.onSubmit(convertSimpleCommentToContentState(comment)),
});

export default _.flowRight(
  mapProps(mapper), // this HOC must go before the reduxForm
  reduxForm(formConfig),
  withTranslate,
  withFontClassName
)(CommentBar);



// WEBPACK FOOTER //
// ./app/components/comment-bar/comment-bar.js